import React from 'react'
import { Link, graphql } from 'gatsby'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import styles from './contact.module.scss'
import Layout from '../components/layout'

class Privacy extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')

    return (
      <Layout location={this.props.location}>
        <div style={{ background: '#fff' }}>
          <Helmet title={siteTitle} />
          <div className={`${styles.classesBlock}`} style={{ padding: '1rem' }}>
            <div className={`${styles.titleContainer}`}>
              <h2 className={`${styles.classesTitle} heading h1`}>Privacy</h2>
              <p className={` body-text `}>
                Our aim is to safeguard our users’ privacy whilst providing a
                personalised and valuable service.
              </p>
            </div>
            <div className={`${styles.ledeContainer}`}>
              <p className={`${styles.dingo} heading h4 `}>
                This statement explains the privacy and the data protection
                practices which apply to aberystwythgymnasticsclub.co.uk
              </p>
            </div>
          </div>
        </div>
        <div className="wrapper">
          <div id="content" className="content" role="main">
            <p>
              Collecting personal information is necessary if we are to satisfy
              the expectations and requirements of our users, e.g. by
              communicating with them and providing an interactive service. We
              appreciate that you do not want the personal information you
              provide to us distributed indiscriminately and here we explain
              what information we collect, what we do with it and what controls
              you have.
            </p>
            <h3>Security</h3>
            <p>
              At&nbsp;aberystwythgymnasticsclub.co.uk we are committed to
              protecting your privacy, we follow strict security procedures to
              ensure that your personal information is not damaged, destroyed,
              or disclosed to a third party without your permission, and to
              prevent unauthorised access. The computers that store the
              information are kept in a secure facility with restricted physical
              access, and we use secure firewalls and other measures to restrict
              electronic access.
            </p>
            <h3>Personal Information</h3>
            <p>
              Any personal information such as name, postal address, telephone
              number, and email address given via this website will only be used
              to provide a requested service and will not be disclosed to any
              other third party without your prior permission or unless we are
              required to do so by law.
            </p>
            <h3>General Information</h3>
            <p>
              Any non-personal information such as IP address, pages accessed,
              and files downloaded will only be used to determine how many
              individuals use our site, how many people visit on a regular
              basis, which pages are most popular, and which pages are least
              popular. This information doesn’t tell us anything about who you
              are or where you live, it is simply used to enable us to monitor
              and improve our service.
            </p>
            <h3>Links</h3>
            <p>
              This website may contain links to third party sites we have no
              control over, if you visit those sites you should check you are
              happy with their own privacy policies and terms of use before
              providing any personal information. In addition, if you linked to
              our website from a third party, we cannot be responsible for the
              privacy policies and practices of that third party site.
            </p>
            <h3>Your Acceptance</h3>
            <p>
              By using this website, you consent to the collection and use of
              information by aberystwythgymnasticsclub.co.uk in accordance with
              our privacy policy. If you do not agree to this policy, please do
              not use our site.
            </p>
            <h3>Your Rights</h3>
            <p>
              Any personal information submitted via our website is treated in
              accordance with the Data Protection Act 1998, registration number.
              To find out more about your entitlements under this legislation,
              visit the Information Commissioner’s website at www.ico.gov.uk or
              read the Act online at www.legislation.gov.uk/ukpga.
            </p>
            <p>
              If you would like to review or revise information you have
              previously provided to us online, or you have any questions
              relating to this Privacy Policy, you may do so via our contact us
              page.
            </p>
            <h3>Our Use of Cookies</h3>
            <p>
              Our website uses various cookies to enhance your user experience.
              Cookies are small files that are often placed onto your computer
              via your web browser automatically when you visit a website.
            </p>
            <p>These cookies allow us to (Cookie Type/Name):</p>
            <ul>
              <li>Run our website (WordPress &amp; PHP Sessions)</li>
              <li>Provide dynamic content (Image Sliders &amp; Cookie Bar)</li>
              <li>
                Understand your usage of our website in order to improve it in
                the future (Google Analytics)
              </li>
            </ul>
          </div>
          <div id="content" className="content" role="main">
            <h3>Legal Notice</h3>
            <p>
              Access to this website is confirmation of your understanding and
              agreement to be bound by all of the following Terms and
              Conditions. Use of this website is prohibited unless you agree to
              all the Terms and Conditions below.
            </p>
            <p>
              We reserve the right to change any of the Terms and Conditions at
              any time. References to ‘you’, ‘your’ and ‘yours’ are references
              to the person(s) accessing this website. References to ‘we’, ‘us’
              and ‘our’ are references to aberystwythgymnasticsclub.co.uk
              Copyright Notice
            </p>
            <p>
              The copyright and all other intellectual property rights in this
              website (including all text, graphics, code, files, database
              rights and links) belong to us. You may print out, save or
              download individual selections only for your own personal, private
              and non-commercial use.
            </p>
            <p>
              You must not print out, save, download, copy, reproduce,
              republish, transmit, broadcast, display, modify or re-use any part
              or content of this website for any other purpose, including in
              particular any purpose which re-sells or re-uses the content in
              any way, without our prior written consent.
            </p>
            <h3>Data Protection</h3>
            <p>
              Any details which you provide us with from which we can identify
              you are held and processed in accordance with our Data Protection
              Registration. See our Website Privacy Policy for further details.
            </p>
            <h3>Law and Jurisdiction</h3>
            <p>
              These Terms &amp; Conditions and any matter relating to this
              website shall be governed and construed in accordance with the
              laws of England and Wales. Any dispute relating to the use of this
              website will be subject to the exclusive jurisdiction of the
              courts of England and Wales.
            </p>
            <p>
              This website is aimed at users in the United Kingdom. Users of
              this website who access it from places outside the United Kingdom
              do so voluntarily and are responsible for complying with any local
              laws.
            </p>
            <h3>IP Addresses</h3>
            <p>
              We may log IP addresses to help diagnose problems with our servers
              and for system administration. We shall only use these addresses
              for technical &amp; tracking purposes.
            </p>
            <h3>Logging</h3>
            <p>
              MailChimp &amp; Contact Form 7 use your&nbsp;email address to
              contact you only if you have given permission to do, your email
              will not be taken without your knowledge. By signing up
              to&nbsp;the waiting list, you agree to the terms and conditions.
            </p>
            <h3 />
          </div>
        </div>
      </Layout>
    )
  }
}

export default Privacy
